var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageTab from '../../organisms/LanguageTab';
import { SupportedLanguages } from '../../../locales';
import OfferListSummary from '../../organisms/OfferListSummary';
import useDirectlyUpdatableTextField from '../../../hooks/hoc/useDirectlyUpdatableTextField';
import TextField from '../../atoms/TextFieldNew';
var OfferSummariesForm = function (_a) {
    var offerSummaries = _a.offerSummaries, onUpdate = _a.onUpdate;
    var t = useTranslation().t;
    var _b = React.useState('ja'), language = _b[0], setLanguage = _b[1];
    var handleUpdate = React.useCallback(function (value, field) {
        var _a;
        var nextOfferSummaries = __assign(__assign({}, offerSummaries), (_a = {}, _a[field] = value, _a));
        onUpdate(nextOfferSummaries, 'offer_summaries');
    }, [offerSummaries, onUpdate]);
    var DirectUpdateTextField = useDirectlyUpdatableTextField(TextField);
    return (React.createElement("div", null,
        React.createElement(LanguageTab, { title: t('params.offerList.offerSummary'), language: language, onChange: function (_, value) { return setLanguage(value); } }),
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 }, SupportedLanguages.map(function (lang) { return (React.createElement(DirectUpdateTextField, { key: lang, fullWidth: true, multiline: true, rows: 5, margin: "normal", label: t('params.offerList.offerSummary'), style: {
                    display: lang == language ? 'block' : 'none',
                }, name: lang, value: offerSummaries[lang], onUpdate: handleUpdate })); })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(Typography, { variant: "caption" }, "preview"),
                React.createElement(OfferListSummary, { content: offerSummaries[language] })))));
};
export default OfferSummariesForm;
